export * from './lib/dialog.module';

export { AccredibleDialogService } from './lib/service/dialog.service';
export { AccredibleDialogTemplateComponentModule } from './lib/dialog-template/dialog-template.component.module';
export { AccredibleConfirmDialogComponentModule } from './lib/confirm-dialog/confirm-dialog.component.module';
export { AccredibleConfirmDialogData } from './lib/confirm-dialog/models/confirm-dialog.model';
